import React, { useEffect, useState, useContext } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthProvider'; // Adjust the path to your AuthProvider
import { toast } from 'react-hot-toast';

const FacebookCallBack = () => {
    // Get the setUser function from AuthContext to update the user state globally
    const { setUser } = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    // State to manage loading and error messages
    const [statusMessage, setStatusMessage] = useState("Processing your Facebook login, please wait...");
    const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api/";

    useEffect(() => {
        // Get the authorization 'code' from the URL query parameters
        const code = searchParams.get("code");
        const error = searchParams.get("error");

        // Handle cases where the user denies access or an error occurs
        if (error) {
           
            navigate("/login");
            return;
        }

        // If a code is found, send it to the backend
        if (code) {
            // Use fetch to send the code to your backend's facebook callback endpoint.
            // A POST request is generally more secure for sending codes.
            fetch(`${baseUrl}auth/facebook/callback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ code }),
            })
            .then(res => {
                // If the response is not ok (e.g., 400 or 500 error), handle it
                if (!res.ok) {
                    return res.json().then(errData => {
                        throw new Error(errData.message || 'Authentication failed on the server.');
                    });
                }
                return res.json();
            })
            .then(data => {
                // If the backend responds with success and a token
                if (data.success && data.token) {
                    // Store the token and update the user state
                    localStorage.setItem("token", data.token);
                    setUser(data.user);
                    toast.success("Login successful!");

                    // Redirect to the home page or the page the user was on before
                    const from = location.state?.from?.pathname || "/";
                    navigate(from, { replace: true });
                } else {
                    // Handle cases where the backend process fails
                    throw new Error(data.message || 'Failed to process login.');
                }
            })
            .catch(err => {
                // Handle any network errors or errors thrown above
                console.error("Facebook Callback Auth Error:", err);
                toast.error(err.message || "An unexpected error occurred.");
                setStatusMessage("Login failed. Redirecting...");
                // Redirect back to the login page on failure
                navigate("/login");
            });
        } else {
            // If no code is found, it's an invalid callback
            toast.error("Invalid callback from Facebook.");
            navigate("/login");
        }
    // The dependency array ensures this effect runs only when necessary
    }, [searchParams, baseUrl, navigate, setUser, location.state]);

    // This is the UI that will be displayed while the callback is processed
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
            fontFamily: 'sans-serif',
            backgroundColor: '#f4f7f9'
        }}>
            <h2 style={{ marginBottom: '20px', color: '#333' }}>{statusMessage}</h2>
            {/* You can add a CSS spinner here for a better visual effect */}
            <div className="spinner"></div> 
            <style>{`
                .spinner {
                    border: 4px solid rgba(0, 0, 0, 0.1);
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    border-left-color: #09f;
                    animation: spin 1s ease infinite;
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default FacebookCallBack;

